import { EmblaOptionsType } from 'embla-carousel';
import EmblaCarousel from "./EmblaCarousel";
import '../../../../css/emblaKidsPlayground.css';
import { Container } from './styles';

// Optionen für das Karussell
const OPTIONS: EmblaOptionsType = { loop: true }

// Bilder mit Text
const SLIDES = [
  { 
    image: require('../../../../assets/images/KidsPlayground/Carousel/1_Ausmalbild-Hexenmaske.png'),
    title: "Eckenmoorhexenmaske",
    description: "Ausmalbild",
    link: require('../../../../data/documents/Ausmalbild-Hexenmaske.pdf')
  },
  { 
    image: require('../../../../assets/images/KidsPlayground/Carousel/2_Ausmalbild-Hexe.png'),
    title: "Eckenmoorhexe",
    description: "Ausmalbild",
    link: require('../../../../data/documents/Ausmalbild-Hexe.pdf')
  },
  { 
    image: require('../../../../assets/images/KidsPlayground/Carousel/3_Bastelvorlage_Eckenmoorhexe.png'),
    title: "Eckenmoorhexe",
    description: "Bastelvorlage",
    link: require('../../../../data/documents/Bastelvorlage_Eckenmoorhexe.pdf')
  }
]

const ImpressionsContainer = () => {
    return (
        <Container>
            <EmblaCarousel slides={SLIDES} options={OPTIONS} />
        </Container>
    );
}

export default ImpressionsContainer;
